import { partitionStaticAndDynamicQuestionnaire } from '../../../common/side-popover-panel/utils';
import type { AnnotationLabelT, AnswerT } from '../../../common/types/types';
import { getAnnotationQuestionnaireId, validateQuestionnaireAnswers } from '../../../common/utils/questionnaire-validation';
import type { CachedQuestionnaireStatus } from '../../../modernization-common/side-panel/atoms/questionnaire.atom';
import type { DynamicAnswerSpanT } from '../studio-store/types';
export type AnnotationQuestionnairePendingInputT = {
  annotationLabel: AnnotationLabelT;
  answers?: AnswerT;
  dynamicAnswers?: DynamicAnswerSpanT[];
};
const getQuestionnairePendingStatus = (annotation: AnnotationQuestionnairePendingInputT, questionnaireCache: Record<string, CachedQuestionnaireStatus>): {
  staticPending: boolean;
  dynamicPending: boolean;
} => {
  const questionnaireId = getAnnotationQuestionnaireId(annotation);
  if (!questionnaireId) {
    return {
      staticPending: false,
      dynamicPending: false
    };
  }
  const cachedQuestionnaire = questionnaireCache[questionnaireId];
  if (!cachedQuestionnaire || cachedQuestionnaire.status !== 'success') {
    return {
      staticPending: true,
      dynamicPending: true
    };
  }
  const {
    dynamicQuestionnaire,
    staticQuestionnaire
  } = partitionStaticAndDynamicQuestionnaire(cachedQuestionnaire.questionnaire);
  const staticPending = staticQuestionnaire.topQuestionIds.length !== 0 && !validateQuestionnaireAnswers(staticQuestionnaire, annotation.answers);
  const dynamicAnswers = annotation.dynamicAnswers ?? [];
  const dynamicPending = dynamicQuestionnaire.topQuestionIds.length !== 0 && (dynamicAnswers.length === 0 || dynamicAnswers.some(({
    answers
  }) => !validateQuestionnaireAnswers(dynamicQuestionnaire, answers)));
  return {
    staticPending,
    dynamicPending
  };
};
export const isAnnotationQuestionnairePending = (annotation: AnnotationQuestionnairePendingInputT, questionnaireCache: Record<string, CachedQuestionnaireStatus>): boolean => {
  const {
    staticPending,
    dynamicPending
  } = getQuestionnairePendingStatus(annotation, questionnaireCache);
  return staticPending || dynamicPending;
};
export const getAnnotationQuestionnairePendingStatus = (annotation: AnnotationQuestionnairePendingInputT, questionnaireCache: Record<string, CachedQuestionnaireStatus>): {
  dynamicQuestionnairePending: boolean;
  staticQuestionnairePending: boolean;
} => {
  const {
    staticPending,
    dynamicPending
  } = getQuestionnairePendingStatus(annotation, questionnaireCache);
  return {
    staticQuestionnairePending: staticPending,
    dynamicQuestionnairePending: dynamicPending
  };
};